import { Outlet } from 'react-router';

import { useLocalStorage } from '@uidotdev/usehooks';

import Providers from '@/providers';
import { generateSessionId } from '@/utils/user.utils';

import useLogRocketIdentify from '@/hooks/useLogRocketIdentify';

function Root() {
  useLocalStorage('sessionId', generateSessionId());
  useLogRocketIdentify();

  return (
    <Providers>
      <Outlet />
    </Providers>
  );
}

export default Root;
